import { Loader } from "@mantine/core"
import { InfoBox } from "@tfg/ui"
import { FC } from "react"
import { useTranslation } from "react-i18next"

import { FindMappingByTypeResponseDto } from "~/gen/api"
import { useFindTypeKeysQuery } from "~/pages/Admin/Mapping/hooks/useFindTypeKeysQuery"
import {
  MappingCollapseProps,
  MappingTypeNames,
  Pagination,
} from "~/pages/Admin/Mapping/types"

import { MappingTable } from "../components/MappingTable"

type Props = MappingCollapseProps & {
  productTypes: FindMappingByTypeResponseDto["mappings"]
  pagination: Pagination
  search: string
  setSearch: (search: string) => void
}

export const ProductMapping: FC<Props> = ({
  productTypes,
  pagination,
  search,
  setSearch,
  isOpen,
  close,
  open,
}) => {
  const {
    data: productTypesList,
    isPending: isLoading,
    isError,
  } = useFindTypeKeysQuery(MappingTypeNames.PRODUCT)
  const { t } = useTranslation()

  if (isLoading) {
    return <Loader />
  }

  if (isError) {
    return (
      <InfoBox
        variant="error"
        title={t("dataLoad.error.title")}
        message={t("dataLoad.error.message")}
      />
    )
  }

  return (
    <>
      <MappingTable
        types={productTypes}
        typesList={productTypesList.data.map((type) => ({
          ...type,
          deletedAt: type.deletedAt ? new Date(type.deletedAt) : null,
        }))}
        typeName={MappingTypeNames.PRODUCT}
        pagination={pagination}
        search={search}
        setSearch={setSearch}
        isOpen={isOpen}
        close={close}
        open={open}
      />
    </>
  )
}
